import React, { useState, useEffect, useCallback } from "react";
import { global_var } from "../../services/cs-lab-config";
import IdeHeader from "./ide-header";
import { useParams } from "react-router-dom";
import { getIdeProjectDetails } from "../../services/ide-apis";
import { message } from "antd";
import cybersquareCat from "../../assets/images/cybercat.gif";
import { useLocation } from 'react-router-dom';
import { notifyProjectCreated } from "../../services/subscription-gate-service";

const notifiedProjectIds = new Set();

const VisualCodingIde = () => {
  document.title = "CS Lab | VC3 IDE";

  let { ideProjectId } = useParams();

  const [ideProjectDetails, setIdeProjectDetails] = useState(undefined);
  const updateProjectDetails = useCallback((updatedProject) => {
    setIdeProjectDetails({ ...updatedProject });
  }, []);
  const [isLoading, setShowSpinner] = useState(true); // State to track loading status
  const [vc3Url, setVc3Url] = useState(undefined);
  const [fkResourceId, setFkResourceId] = useState(undefined);
  const [fkActivityMapping, setFkActivityMapping] = useState(undefined);
  const [fkUserActivityMappingId, setFkUserActivityMappingId] = useState(undefined);
  const [isEval, setIsEval] = useState(undefined);
  const [isLoadingProgress, setisLoadingProgress] = useState(true);

  const location = useLocation();
  // const userToken = localStorage.getItem("token");
  // Read the token once per mount: the API interceptor may rotate it (Refresh-Token),
  // and a changed token would rebuild vc3Url and reload the iframe, discarding the open project.
  const [userToken] = useState(() => sessionStorage.getItem('token'));

  useEffect(() => {  
    const queryParams = new URLSearchParams(location.search);
    
    if(queryParams.get('isEval')){
      setIsEval(queryParams.get('isEval'))
    }

    if(queryParams.get('fkResourceId')){
      setFkResourceId(queryParams.get('fkResourceId'))
    }

    if(queryParams.get('fkActivityMapping')){
      setFkActivityMapping(queryParams.get('fkActivityMapping'))
    }

    if(queryParams.get('fkUserActivityMappingId')){
      setFkUserActivityMappingId(queryParams.get('fkUserActivityMappingId'))
    }
    setTimeout(() => {
      setisLoadingProgress(false)
    }, 500); 

    const handler_fn = (event) => {
      if (event.data.from === "vc3") {
          if (event.data.response) {
            const response = JSON.parse(event.data.response)
            if (response.ideProjectId && response.statusCode === 200) {
              if (response.ideProjectId !== ideProjectId && !notifiedProjectIds.has(response.ideProjectId)) {
                notifiedProjectIds.add(response.ideProjectId); // a newly created project, not a save
                notifyProjectCreated();
              }
              getIdeProjectDetails(response.ideProjectId).then((response) => {
                response = response.data;
                if (response.statusCode === 200) {
                  setIdeProjectDetails(response.projectDetails);
                }
              });

            }
          }
      }
    };
    
    window.addEventListener('message', handler_fn);
    
    return () => {
        window.removeEventListener('message', handler_fn);
    };

  }, [location, ideProjectId]);

  useEffect(() => {
    if (ideProjectId) {
      getIdeProjectDetails(ideProjectId).then((response) => {
        response = response.data;

        if (response.statusCode === 200) {
          if (
            response.projectDetails.fkUserLoginId ===
              global_var.user_login_id ||
            global_var.role_id !== global_var.STUDENT_ROLE_ID
          ) {
            setIdeProjectDetails(response.projectDetails);


            if (response.projectDetails.fkResourceId && 
              response.projectDetails.fkActivityMapping && 
              response.projectDetails.totalMark > 0) {
            }

          } else {
            message.error("Your session expired. Please login again");
          }
        } else {
          message.error(response.message);
        }
      });

      if ((isEval? isEval === "true": false) && !fkResourceId) {
        setVc3Url(
          global_var.SCRATCH_ENDPOINT +
            "?token=" +
            userToken +
            "&lmsProjectId=" +
            ideProjectId +
            "&isEvaluate=true"
        );
      }else if ((isEval? isEval === "true": false) && fkResourceId) {
        setVc3Url(
          global_var.SCRATCH_ENDPOINT +
            "?token=" +
            userToken +
            "&lmsProjectId=" +
            ideProjectId +
            "&isEvaluate=true" + 
            "&fkResourceId=" + 
            fkResourceId + 
            "&fkActivityMapping=" + 
            fkActivityMapping + 
            "&fkUserActivityMappingId=" + 
            fkUserActivityMappingId
        );

      } 
      else if (!isEval && fkResourceId) {
        setVc3Url(
          global_var.SCRATCH_ENDPOINT +
            "?token=" +
            userToken +
            "&lmsProjectId=" +
            ideProjectId +
           "&fkResourceId=" + fkResourceId + "&fkActivityMapping=" + fkActivityMapping + "&fkUserActivityMappingId=" + fkUserActivityMappingId + "&origin=lab_assignment"
        );
      } 
      else {
        setVc3Url(
          global_var.SCRATCH_ENDPOINT +
            "?token=" +
            userToken +
            "&lmsProjectId=" +
            ideProjectId
        );
      }
    }else if(fkResourceId && fkActivityMapping){
      setVc3Url(global_var.SCRATCH_ENDPOINT + "?fkResourceId=" + fkResourceId + "&fkActivityMapping=" + fkActivityMapping + "&fkUserActivityMappingId=" + fkUserActivityMappingId + "&origin=lab_assignment&token=" + userToken);
    } else {
      setVc3Url(global_var.SCRATCH_ENDPOINT + "?token=" + userToken);
    }
  }, [ideProjectId, userToken, isEval, fkResourceId, fkActivityMapping, fkUserActivityMappingId]);

  // Function to handle iframe load event
  const handleIframeLoad = () => {
    setShowSpinner(false); // Set loading status to false when iframe content is loaded
  };


  return (
    <div className="container-fluid p-0">
      <div className="row">
        <div className="col">
          <IdeHeader
            headerName="Scratch IDE"
            hidePortfolio={true}
            ideProjectDetails={ideProjectDetails}
            fkResourceId={fkResourceId}
            onUpdateProjectDetails={updateProjectDetails}
          />
          {isLoading && (
            <div
              style={{
                textAlign: "center",
                marginTop: "10rem",
              }}
            >
              <img
                src={cybersquareCat}
                width="200px"
                alt="Loader"
                height="120px"                
              />
              <div className="text-secondary font-weight-bold poppins-regular">Please wait !! Your project is loading...</div>
            </div>
          )}


          {/* end eval */}
          <div className="row">
            <div className="col">
              {!isLoadingProgress && (
                <iframe
                  id="vc3Iframe"
                  src={vc3Url}
                  title="vc3"
                  allow='camera; microphone'
                  onLoad={handleIframeLoad} // Attach the load event handler
                  style={{
                    width: "100%",
                    height: "90vh",
                    border: "none",
                    marginTop: "5px",
                    // display: isLoading? 'none': 'block'
                  }}
                ></iframe>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default VisualCodingIde;